import { Link } from "office-ui-fabric-react"

const TimeTrackingAdministrativeTooltip = () => {
    return <span>
        Create and manage administrative categories that users in your tenant will report time on. Please
        refer to the <Link
            target="_blank"
            href="https://help.ppm.express/89495-ppm-express-settings/2610325-time-tracking-settings#section-3">
            article
        </Link> for more details.
    </span>
}

export default TimeTrackingAdministrativeTooltip;